import React, { useState, useEffect } from "react";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { getHelpCenterCategoryList } from "../../../../../services/workspace/helpCenterCategory.service";
import HelpCenterSearch from "../../components/helpCenterSearch";

const breadcrumbs = [
  { label: "Home", path: "/" },
  { label: "Help Center", path: "" },
];

function HelpCenter() {
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState([]);

  useEffect(() => {
    setLoading(true);
    getHelpCenterCategoryList()
      .then((response) => { 
        setLoading(false);
        setData(Array.isArray(response.data) ? response.data : []);
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Failed to fetch the category data!");
        console.error("Error fetching data:", error);
      });
  }, []);

  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader
        breadcrumbs={breadcrumbs}
        isSearch={false}
        onSearchChange={(e) => setSearch(e.target.value)}
        isFilter={false}
        buttons={false}
      />

      <div className="flex flex-col gap-4 bg-white p-4 text-theme">
        <HelpCenterSearch />
        <div className="flex flex-row justify-between items-end">
          <div>
            <p className="font-bold text-md">Need help? We got your back</p>
            <p className="text-textLight">
              Perhaps you can find your answers in our collections
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-4 grid-cols-2 gap-3 max-h-96 overflow-y-auto">
          {loading
            ? Array.from({ length: 4 }).map((_, index) => (
                <Card key={index} loading={loading} />
              ))
            : data &&
              data.length > 0 &&
              data?.map((item, index) => {
                return (
                  <Card
                    key={index}
                    title={item.title}
                    detail={item.description}
                    id={item.uuid}
                  />
                );
              })}
        </div>
      </div>
    </div>
  );
}

const Card = ({ title, detail, id, loading }) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => !loading && navigate(`detail/${id}`)}
      className="flex flex-col gap-2 justify-between rounded-md bg-light p-3 hover:bg-bghoverlight cursor-pointer"
    >
      <div className="flex flex-col gap-1 p-2">
        {loading ? (
          <div className="flex flex-col gap-1">
            <div className="w-1/2 h-4 bg-primary-200 animate-pulse rounded-md"></div>
            <div className="w-3/4 h-3 bg-primary-200 animate-pulse rounded-md"></div>
          </div>
        ) : (
          <>
            <span className="text-md font-bold text-theme">{title}</span>
            <span className="text-sm text-textLight">{detail}</span>
          </>
        )}
      </div>
    </div>
  );
};

export default HelpCenter;
